"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useAddNewCardStyles = () => {
    const theme = (0, material_1.useTheme)();
    const cardStyles = {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        background: `linear-gradient(0deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.main}), ${theme.qlub.palette.white.main}`,
        borderRadius: '8px',
    };
    const footerIconStyles = {
        width: '16px',
        height: '16px',
        color: theme.palette.primary.main,
    };
    const errorTextStyles = Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.danger.main, marginTop: '8px' });
    const headerStyles = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
        borderRadius: '8px',
        padding: '8px 16px',
    };
    const cancelIconStyles = { color: theme.palette.primary.main };
    const headerTextStyles = Object.assign({}, theme.qlub.typography.body_sm);
    const creditCardsStyles = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0',
        gap: '8px',
        flexGrow: 1,
        '& svg': {
            width: '32px',
            height: '32px',
        },
    };
    const cardInfoAreaStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        padding: '16px',
    };
    const cvvAndDateStyles = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '0',
        gap: '16px',
        width: '100%',
    };
    const dividerStyles = {
        background: `linear-gradient(0deg, ${theme.qlub.palette.iris_light.focus} , ${theme.qlub.palette.iris_light.focus}), ${theme.qlub.palette.white.main}`,
    };
    const footerStyles = {
        padding: '16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        height: '49px',
        borderRadius: '8px',
    };
    const footerTextStyles = {
        fontFamily: 'inherit',
        fontWeight: 400,
        fontSize: '12px',
        letterSpacing: '0.04em',
    };
    return {
        cardStyles,
        errorTextStyles,
        headerStyles,
        cancelIconStyles,
        headerTextStyles,
        creditCardsStyles,
        cardInfoAreaStyles,
        cvvAndDateStyles,
        dividerStyles,
        footerStyles,
        footerTextStyles,
        footerIconStyles,
    };
};
exports.default = useAddNewCardStyles;
